import { objectWithoutProperties as _objectWithoutProperties, objectSpread2 as _objectSpread2, extends as _extends } from '../_virtual/_rollupPluginBabelHelpers.js';
import React, { useMemo } from 'react';
import { utils, ListItemIcon, Checkbox, Icon, ListItemText as ListItemText$1, ListItem as ListItem$1 } from '@costar/theme-ui';
import ReactHtmlParser from 'react-html-parser';

var _excluded = ["sx"];
var ListItemText = /*#__PURE__*/React.memo(ListItemText$1);
var ListItem = /*#__PURE__*/React.memo(ListItem$1);
var checkboxSx = {
  pointerEvents: 'none'
};
var TransferListItem = function TransferListItem(props) {
  var _availableOptions$val;
  var activeListSearchProps = props.activeListSearchProps,
    availableOptions = props.availableOptions,
    checked = props.checked,
    hasLockSelections = props.hasLockSelections,
    isSelectedList = props.isSelectedList,
    lastChecked = props.lastChecked,
    lastSelectedRef = props.lastSelectedRef,
    _props$listItemProps = props.listItemProps,
    listItemProps = _props$listItemProps === void 0 ? utils.EMPTY_OBJECT : _props$listItemProps,
    showCheckBox = props.showCheckBox,
    showLockIcon = props.showLockIcon,
    value = props.value,
    style = props.style,
    handleToggle = props.handleToggle;
  var labelId = "transfer-list-item-".concat(value, "-label");
  var option = (_availableOptions$val = availableOptions[value]) !== null && _availableOptions$val !== void 0 ? _availableOptions$val : {};
  var isDisabled = hasLockSelections && isSelectedList && option.lock;
  var sxListItemProps = listItemProps.sx,
    restListItemProps = _objectWithoutProperties(listItemProps, _excluded);
  var listItemSx = useMemo(function () {
    return _objectSpread2(_objectSpread2({}, hasLockSelections ? {
      '& .lock-icon': {
        opacity: 0
      },
      '&.is-selected .lock-icon': {
        opacity: 1,
        color: 'inherit'
      },
      '&.is-disabled .lock-icon': {
        opacity: 1
      }
    } : {}), sxListItemProps);
  }, [hasLockSelections, sxListItemProps]);
  // eslint-disable-next-line no-console
  // console.log(`---- rendering transfer-list-item ${value} ----`)
  return /*#__PURE__*/React.createElement(ListItem, _extends({
    ref: isSelectedList && lastChecked === value ? lastSelectedRef : null,
    role: "listitem",
    onClick: isDisabled ? undefined : handleToggle(value),
    onDoubleClick: isDisabled ? undefined : handleToggle(value, true),
    selected: checked,
    style: style,
    resetCss: utils.EMPTY_OBJECT
  }, _objectSpread2({
    disabled: isDisabled
  }, restListItemProps), {
    sx: listItemSx
  }), showCheckBox && /*#__PURE__*/React.createElement(ListItemIcon, null, /*#__PURE__*/React.createElement(Checkbox, {
    checked: checked,
    tabIndex: -1,
    "aria-labelledby": labelId,
    sx: checkboxSx
  })), /*#__PURE__*/React.createElement(ListItemText, {
    id: labelId,
    primary: !isSelectedList && activeListSearchProps.search ? ReactHtmlParser(activeListSearchProps.highlightedStrings[value]) : option.label
  }), hasLockSelections && showLockIcon && /*#__PURE__*/React.createElement(Icon, {
    className: "lock-icon",
    emMarginLeft: "xs",
    icon: isSelectedList && option.lock ? 'lock' : 'unlock'
  }));
};

export default TransferListItem;
//# sourceMappingURL=transfer-list-item.esm.js.map
